import { GlobalSpinner } from '@scouts/ui'

import { useAppSelector } from '@/store'

export const RequestObserver = () => {
    const shouldDisplayGlobalSpinner = useAppSelector((state) => state.request.requestPending)

    if (shouldDisplayGlobalSpinner) return <GlobalSpinner />

    return null
}
